module.exports = __webpack_public_path__ + "img/bottom_icon04.b370521.png";